//毫秒转换为格式化日期
function formatFn(time, format) {
	if (time) {
		var t = new Date(time);
		var tf = function(i) {
			return (i < 10 ? '0' : '') + i
		};
		return format.replace(/yyyy|MM|dd|HH|mm|ss/g, function(a) {
			switch (a) {
				case 'yyyy':
					return tf(t.getFullYear());
					break;
				case 'MM':
					return tf(t.getMonth() + 1);
					break;
				case 'mm':
					return tf(t.getMinutes());
					break;
				case 'dd':
					return tf(t.getDate());
					break;
				case 'HH':
					return tf(t.getHours());
					break;
				case 'ss':
					return tf(t.getSeconds());
					break;
			}
		})
	} else {
		return "";
	}

}
//alert(formatDate(new Date().getTime(), 'yyyy-MM-dd HH:mm:ss'))
export {
	formatFn
}



//////////////////
// WEBPACK FOOTER
// ./static/js/date.js
// module id = null
// module chunks = 